import clsx from "clsx";
import { PropsWithChildren, useCallback, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./RechnerForm.module.scss";

export type HintProps = PropsWithChildren<{}>;

const portalRoot = document.getElementById("root") || document.body;

function Hint({ children }: HintProps) {
  const [showHint, setShowHint] = useState(false);
  const [anchorRef, setAnchorRef] = useState<HTMLDivElement | null>(null);
  const [portalRef, setPortalRef] = useState<HTMLDivElement | null>(null);

  const posRefCallback = useCallback((node: HTMLDivElement) => {
    if (node) {
      if (node.hasAttribute("data-anchor")) {
        setAnchorRef(node);
      } else if (node.hasAttribute("data-portal")) {
        setPortalRef(node);
      }
    }
  }, []);

  const anchorElement = (
    <div
      ref={posRefCallback}
      data-anchor={true}
      className={styles.hintContainer}
      onMouseEnter={() => {
        setShowHint(true);
      }}
      onMouseLeave={() => {
        setShowHint(false);
      }}
    >
      i
    </div>
  );

  const position = {
    top: 0,
    left: 0,
  };

  if (anchorRef && portalRef) {
    const anchorRect = anchorRef.getBoundingClientRect();
    const portalRect = portalRef.getBoundingClientRect();
    position.top = anchorRect.top + anchorRect.height + 10 + window.scrollY;
    position.left = anchorRect.left - portalRect.width / 2;
  }

  const hintElement = (
    <div
      data-portal={true}
      ref={posRefCallback}
      className={clsx(styles.hint, styles.show)}
      style={{ top: position.top, left: position.left }}
    >
      {children}
    </div>
  );

  return (
    <>
      <div style={{ position: "relative" }}>
        {anchorElement}
        {showHint && createPortal(hintElement, portalRoot)}
      </div>
    </>
  );
}

export default Hint;
